import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModalTitleWrapper = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: '1rem'
}));
